import { render, staticRenderFns } from "./FansPortrait.vue?vue&type=template&id=424da0a9&scoped=true"
import script from "./FansPortrait.vue?vue&type=script&lang=js"
export * from "./FansPortrait.vue?vue&type=script&lang=js"
import style0 from "./FansPortrait.vue?vue&type=style&index=0&id=424da0a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424da0a9",
  null
  
)

export default component.exports